
    <div class="container">
      <div class="mat-title">
        {{ 'move-locations' | translate | titlecase }}
      </div>

      <mat-form-field class="full-width">
        <mat-label>{{ 'location' | translate | titlecase }}</mat-label>
        <input
          matInput
          value="{{ orderLocationName(data.orderLocationToMove) }}"
          disabled
        />
      </mat-form-field>

      <form [formGroup]="form">
        <mat-form-field class="full-width">
          <mat-label>{{ 'new-position' | translate | titlecase }}</mat-label>
          <input matInput formControlName="newPosition" required />
          <mat-error *ngIf="newPositionControl.hasError('required')">
            {{ 'this-field' | translate | titlecase }} {{ 'is' | translate }}
            <strong>{{ 'required' | translate }}</strong>
          </mat-error>
          <mat-error *ngIf="newPositionControl.hasError('min')">
            {{ 'new-position-too-low' | translate: { value: 0 } }}
          </mat-error>
          <mat-error *ngIf="newPositionControl.hasError('max')">
            {{
              'new-position-too-high'
                | translate: { value: data.orderLocations.length }
            }}
          </mat-error>
        </mat-form-field>
      </form>

      <div fxLayout fxLayoutAlign="end" class="margin-top-16">
        <button mat-button (click)="onToFirst()">
          {{ 'to-first' | translate | titlecase }}
        </button>
        <button mat-button (click)="onToLast()">
          {{ 'to-last' | translate | titlecase }}
        </button>
        <button mat-button (click)="onConfirm()">
          {{ 'confirm' | translate | titlecase }}
        </button>
        <button mat-button (click)="onClose()">
          {{ 'cancel' | translate | titlecase }}
        </button>
      </div>
    </div>
  